import { useInfiniteQuery, UseQueryOptions } from 'react-query'

import { api, useMutationApi, useQueryApi } from 'utils/api'
import { baseAPIPathGuruCore, baseAPIPathGuruKS } from 'configs/api'

import { User, UserGroup } from 'app/AccessManagement/interfaces'

export const basePath = `${baseAPIPathGuruKS}/v1/ks/usermana`

export interface GenericPaginationMeta {
  limit?: number
  offset?: number
  total?: number
}

export interface PaginationWithQuery extends GenericPaginationMeta {
  [key: string]: any
}

export function useAPIUserList(
  { limit = 10, offset = 0, ...query }: PaginationWithQuery,
  enabled = true
) {
  return useInfiniteQuery<{ data: User[]; meta: any }, Error>(
    ['get-user-list', { limit, offset, ...query }],
    async ({ pageParam = { limit, offset, ...query } }) => {
      return await api<{ data: User[]; meta: any }>(
        `${baseAPIPathGuruCore}/v1alpha2/users`,
        {
          params: pageParam,
        }
      )
    },
    { enabled }
  )
}

export function useMutationsAPIGetUserList() {
  return useMutationApi<{ data: User[]; meta: any }, Error, any>(
    `${baseAPIPathGuruCore}/v1alpha2/users`,
    {
      axiosConfig: {
        method: 'GET',
      },
    }
  )
}

interface ParamsGetGroups {
  email: string
  limit: number
}

interface ResponseSuccessGetGroups {
  data: UserGroup[]
}

export const useAPIGetGroups = (
  params: ParamsGetGroups,
  queryConfig: UseQueryOptions<ResponseSuccessGetGroups> = {}
) =>
  useQueryApi<ResponseSuccessGetGroups>(`${basePath}/groups`, {
    axiosConfig: {
      params,
    },
    queryConfig,
  })

interface ResponseSuccessImpersonateGroup {
  data: {
    message: string
  }
}

export interface RequestBodyImpersonateGroup {
  group: 'UPT' | 'DINAS' | 'ADMIN' | 'GTK'
  regionId?: string
}

export const useAPIImpersonateGroup = () =>
  useMutationApi<
    ResponseSuccessImpersonateGroup,
    Error,
    RequestBodyImpersonateGroup
  >(`${basePath}/groups/impersonate`, {
    axiosConfig: {
      method: 'POST',
    },
  })
